import { Box, Chip, makeStyles, styled, Typography } from "@material-ui/core";
import { Button } from "components";
import { Drawer } from "shared";

const STATUS_COLORS = {
  scheduled: {
    background: "#E8F1FD",
    text: "#1D4E89"
  },
  active: {
    background: "#E8F5E9",
    text: "#2E7D32"
  },
  finished: {
    background: "#ECEFF3",
    text: "#45515F"
  },
  cancelled: {
    background: "#FCE8E6",
    text: "#8C2F28"
  }
};

export const useStyles = makeStyles({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem"
  },
  addButton: {
    width: "9rem",
    height: "2.5rem",
    borderRadius: "0.5rem"
  }
});

export const StatusChip = styled(Chip)(({ status }) => {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.finished;

  return {
    backgroundColor: colors.background,
    color: colors.text,
    fontFamily: "Inter",
    fontSize: "0.75rem",
    fontWeight: 600,
    lineHeight: 1,
    "& .MuiChip-label": {
      paddingLeft: "0.625rem",
      paddingRight: "0.625rem"
    }
  };
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "36rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  }
}));

export const FormContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "1.25rem",
  flexGrow: 1
});

export const FormTitle = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "1.125rem",
  fontWeight: 600,
  color: "#353535"
});

export const Actions = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  gap: "0.75rem"
});

export const SaveButton = styled(Button)({
  minWidth: "7rem",
  height: "3rem"
});
